/* eslint-disable react/prop-types */
import React from 'react'

import { Notifications, notifications } from '@mantine/notifications'
import type { NotificationProps } from '@mantine/notifications'

import Danger from 'public/images/danger.svg'
import Info from 'public/images/Info.svg'
import Success from 'public/images/success.svg'
import Warning from 'public/images/warning.svg'

export function NotificationsHandler() {
  return <Notifications position="top-right" zIndex={2077} autoClose={5000} />
}

export const showNotification = ({
  type,
  title,
  ...rest
}: {
  type: 'success' | 'danger' | 'warning' | 'info' | 'firebase'
} & NotificationProps) => {
  const MappingColor = {
    success: 'green',
    danger: 'red',
    warning: 'yellow',
    info: 'blue',
    firebase: 'gray',
  }
  const MappingIcon = {
    success: <Success width={20} height={20} />,
    danger: <Danger width={20} height={20} />,
    warning: <Warning width={20} height={20} />,
    info: <Info width={20} height={20} />,
    firebase: '',
  }
  const icon = MappingIcon[type]
  // Most used notification props
  notifications.show({
    title: <b>{title}</b>,
    icon,
    withCloseButton: true,
    closeButtonProps: {
      label: 'Close alert',
    },
    ...rest,
    styles: (theme) => {
      const mapColor = (MappingColor[type] as any) || 'blue'
      return {
        root: {
          backgroundColor: theme.colors[mapColor][0],
          borderColor: theme.colors[mapColor][0],

          '&::before': { backgroundColor: theme.white },
        },

        title: { color: theme.colors[mapColor][8] },
        description: { color: theme.black },
        closeButton: {
          color: theme.black,
          '&:hover': {
            backgroundColor: theme.colors[mapColor][0],
          },
        },
        icon: {
          backgroundColor: 'transparent',
          padding: 0,
        },
      }
    },
  })
}
